import { type Country, siteConfig } from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types';

const fullCountryNameMapping: Record<Country, string> = {
  au: 'Australia',
  nz: 'New Zealand',
  hk: 'Hong Kong',
  th: 'Thailand',
  sg: 'Singapore',
  id: 'Indonesia',
  my: 'Malaysia',
  ph: 'Philippines',
};

export const mapSiteToFullCountryName = (site: EmployerSiteName) => {
  const country = siteConfig[site].classification.country;
  return fullCountryNameMapping[country];
};
